import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import Router from '@/router/index'

const StatusMessage = {
  400: '（错误请求） 服务器不理解请求的语法。',
  401: '（未授权） 身份验证不通过。',
  403: '（禁止） 服务器拒绝请求。',
  404: '（未找到） 服务器找不到该请求。',
  405: '（方法禁用） 请求方法已被禁用。',
  406: '（不接受） 无法使用请求的内容特性来响应请求。',
  407: '（需要代理授权） 请开启授权使用代理。',
  408: '（请求超时） 服务器等候请求时发生超时。',
  409: '（冲突） 服务器在完成请求时发生冲突。 服务器必须在响应中包含有关冲突的信息。',
  410: '（已删除） 如果请求的资源已永久删除，服务器就会返回此响应。',
  411: '（需要有效长度） 服务器不接受不含有效内容长度标头字段的请求。',
  412: '（未满足前提条件） 服务器未满足请求者在请求中设置的其中一个前提条件。',
  413: '（请求实体过大） 服务器无法处理请求，因为请求实体过大，超出服务器的处理能力。',
  414: '（请求的 URI 过长） 请求的 URI（通常为网址）过长，服务器无法处理。',
  415: '（不支持的媒体类型） 请求的格式不受请求页面的支持。',
  416: '（请求范围不符合要求） 如果页面无法提供请求的范围，则服务器会返回此状态代码。',
  417: '（未满足期望值） 服务器未满足"期望"请求标头字段的要求。',
  500: '（服务器内部错误） 服务器遇到错误，无法完成请求。',
  501: '（尚未实施） 服务器不具备完成请求的功能。 例，服务器无法识别请求方法。',
  502: '（错误网关） 服务器作为网关或代理，从上游服务器收到无效响应。',
  503: '（服务不可用） 服务器目前无法使用（由于超载或停机维护）。 通常，这只是暂时状态。',
  504: '（网关超时） 服务器作为网关或代理，但是没有及时从上游服务器收到请求。',
  505: '（HTTP 版本不受支持） 服务器不支持请求中所用的 HTTP 协议版本。'
}

let requestStop = false

function showErrorMessage (message) {
  MessageBox.alert(message).then().then()
}

// 提示问题
function warningMessage (str) {
  Message && Message({
    message: str || '系统发生未知错误',
    duration: 4000,
    type: 'warning',
    showClose: true
  })
}

// 提示错误
function errorMessage (str) {
  if (!requestStop) {
    Message && Message({
      message: str || '系统发生未知错误',
      duration: 4000,
      type: 'error',
      showClose: true
    })
  }
}

function userOut () {
  if (!requestStop) {
    requestStop = true
    MessageBox.alert('登录已失效，请重新登录').then(() => {
      Router.replace({
        path: '/login'
      })
      requestStop = false
    }).then()
  }
}

// 连接超时时间
axios.defaults.timeout = 60000 * 10
// 跨域是否需要凭证
axios.defaults.withCredentials = false
// 地址追加
// axios.defaults.baseURL = "/";
// 头部添加
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 请求拦截器
axios.interceptors.request.use(res => {
  return res
})

// 响应拦截器
axios.interceptors.response.use(res => {
  return res
})

function request (option) {
  return new Promise(function (resolve, reject) {
    const params = {
      ...option,
      headers: option.headers || {}
    }

    // Loading，参数加loading代表此接口需要遮罩层
    let loading
    let data = option[option.method === 'POST' ? 'data' : 'params']
    if (data && data.loading) {
      loading = Loading.service({
        text: typeof (data.loading) === 'string' ? data.loading : '',
        background: 'rgba(0, 0, 0, 0.6)'
      })
      delete data.loading
    }

    axios(params).then((res) => {
      console.log("res>>>", res);

      loading && loading.close()
      if (res.data.code == 200) {
        console.log(1);
        resolve(res.data)
      } else {
        console.log('else', res);
        reject(res)
        warningMessage(res.data.message)
      }
    }).catch((err) => {
      console.log("err", err);

      loading && loading.close()

      reject(err)

      // 网络失败则直接处理，不往外发
      if (err.response) {
        const status = err.response.status
        const message = StatusMessage[status] || 'status = ' + status
        errorMessage(message)

        if (status === 401) {
          Router.replace({
            path: '/login'
          })
        }
      } else {
        errorMessage('网络异常')
      }
    })
  })
}

export function httpRequest (option) {
  return request(option)
}

export function downloadFile (option) {
  return new Promise((resolve, reject) => {
    request(option).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

//文件转base64
export function getFileData (url) {
  return new Promise((reslove, reject) => {
    axios({
      method: 'get',
      url: url,
      responseType: 'blob'
    }).then((data) => {
      const blob = data
      const fileReader = new FileReader()
      fileReader.readAsDataURL(blob)
      fileReader.onloadend = function (e) {
        const base64 = atob(
          e.target.result.substring(e.target.result.indexOf(',') + 1)
        )
        reslove(base64)
      }
    }).catch((err) => {
      reject(err)
    })
  })
}
